module.exports = __webpack_public_path__ + "static/media/objects2_11.0f673387.svg";